import { useState } from "react";
import { PaginationResult } from "../../../../Shared/Model/PaginationResult";
import UserAPIDataSourceImpl from "../../Data/DataSource/API/UserAPIDataSource";
import { UserRepositoryImpl } from "../../Data/Repository/UserRepositoryImpl";
import { Users } from "../../Domain/Model/Users";
import { CreateUser } from "../../Domain/UseCase/CreateUser";
import { GetUsers } from "../../Domain/UseCase/GetUsers";
import { UpdateStateUser } from "../../Domain/UseCase/UpdateStateProduct";

export default function UserViewModel() {

    const [users, setUsers] = useState<Users[]>();
    const [checkedStates, setCheckedStates] = useState<Record<number, boolean>>({});
    const userDataSourceImpl = new UserAPIDataSourceImpl();
    const userRepositoryImpl = new UserRepositoryImpl(userDataSourceImpl);

    const getUsersUseCase = new GetUsers(userRepositoryImpl);
    const createUserUseCase = new CreateUser(userRepositoryImpl);
    const updateStateUserUseCase = new UpdateStateUser(userRepositoryImpl)

    async function createUsers(data: any) {
        
        try {
          const createdUsers = await createUserUseCase.invoke(data);
          if(createdUsers){
            return true;
          }
        } catch (e) {
          if (e instanceof Error) {
            //console.log(e.message);
          }
        }
    }
    async function getUsers(page: number, size: number, search: string): Promise<{ items: Users[]; totalCount: number }> {
        try {
            const result: PaginationResult<Users> = await getUsersUseCase.invoke(page, size, search );
        
            await setUsers(result.items); // Si quieres mantenerlo en el ViewModel
            setCheckedStates(
            result.items.reduce((acc, user) => {
                acc[user.id ?? 0] = user.status === 0;
                return acc;
            }, {} as Record<number, boolean>)
            );
        
            return {
            items: result.items,
            totalCount: result.totalCount, // usar totalCount según tu interfaz
            };
        } catch (error) {
            console.error("Error al obtener productos:", error);
            return { items: [], totalCount: 0 };
        }
    }

    // async function updateStateUser(data: UserState) {
    //     try {
    //         const updatedStateProduct = await updateStateUserUseCase.invoke(data);
    //         if(updatedStateProduct){
    //         console.log("Actualizado");
    //         return updatedStateProduct;
            
    //         }
           
    //     } catch (e) {
           
    //         if (e instanceof Error) {
    //         console.log(e.message);
    //         }
    //         return Error;
    //     }
    // }

    // const handleSwitchChange = async (checked: boolean, userId: number) => {
    //         // Guardamos el estado anterior en caso de error
    //         const previousState = checkedStates[userId];
    
    //         // Actualizamos el estado en la UI inmediatamente para una mejor experiencia
    //         setCheckedStates((prevStates) => ({
    //         ...prevStates,
    //         [userId]: checked,
    //         }));
    
    //         const stateUpdate: UserState = {
    //         userId: userId,
    //         status: checked ? 0 : 1,
    //         };
    
    //         const success = await updateStateUser(stateUpdate);
    
    //         if (!success) {
    //         console.warn("No se pudo actualizar el estado en la base de datos. Revirtiendo cambio...");
    //         setCheckedStates((prevStates) => ({
    //             ...prevStates,
    //             [userId]: previousState,
    //         }));
    //         }
    // };


      return{
        createUsers,
        users,
        getUsers,
        checkedStates
      };
}